import { render, staticRenderFns } from "./economize.vue?vue&type=template&id=178f3f38&scoped=true"
import script from "./economize.vue?vue&type=script&lang=js"
export * from "./economize.vue?vue&type=script&lang=js"
import style0 from "./economize.vue?vue&type=style&index=0&id=178f3f38&prod&lang=scss&scoped=true"
import style1 from "./economize.vue?vue&type=style&index=1&id=178f3f38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178f3f38",
  null
  
)

export default component.exports